<template>
  <div
    class="second-grab-engine"
    :key="refreshKey"
    data-position="1"
    data-name="秒抢引擎"
  >
    <div class="text-box">
      <p class="subtitle ffm500">秒抢引擎</p>
      <p class="title ffm600">抢票就是快人一步</p>
      <p class="content ffm400" v-if="isPC">
        在你按下按钮的那一刻，立即将算力与网络推到满格优先级。<br />
        无论是演唱会、博物馆、体育赛事门票，还是消费券，甚至专家号，你的响应速度始终快人一步。
      </p>
      <p class="content ffm400" v-else>
        在你按下按钮的那一刻，立即将算力与网络推到满格优先<br />
        级。无论是演唱会、博物馆、体育赛事门票，还是消费券，<br />
        甚至专家号，你的响应速度始终快人一步。
      </p>
    </div>
    <div v-if="isPC" class="sge-swiper">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <div class="bgbox">
            <span class="mq ffm600">秒抢</span>
            <span class="yq ffm600">引擎</span>
            <PlusImage class="bgimg" :src="SECOND_GRAB_ENGINE.bg" alt="" />
            <PlusImage class="hand" :src="SECOND_GRAB_ENGINE.hand" alt="" />
          </div>
          <div class="mask"></div>
          <div class="mask-inside"></div>
        </div>
        <div class="swiper-slide">
          <PlusImage :src="SECOND_GRAB_ENGINE.slide2" alt="" />
        </div>
        <div class="swiper-slide">
          <PlusImage :src="SECOND_GRAB_ENGINE.slide3" alt="" />
        </div>
      </div>
    </div>
    <div v-else class="sge-swiper" v-animate>
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <PlusImage v-if="isPad" :src="SECOND_GRAB_ENGINE.padSlide1" alt="" />
          <PlusImage v-else :src="SECOND_GRAB_ENGINE.h5Slide1" alt="" />
        </div>
        <div class="swiper-slide">
          <PlusImage v-if="isPad" :src="SECOND_GRAB_ENGINE.padSlide2" alt="" />
          <PlusImage v-else :src="SECOND_GRAB_ENGINE.h5Slide2" alt="" />
        </div>
        <div class="swiper-slide">
          <PlusImage v-if="isPad" :src="SECOND_GRAB_ENGINE.padSlide3" alt="" />
          <PlusImage v-else :src="SECOND_GRAB_ENGINE.h5Slide3" alt="" />
        </div>
      </div>
    </div>
    <div class="pagination ffm500">
      <ul>
        <li
          v-for="(txt, i) in pagination"
          :class="{ active: activeIndex === i }"
          :key="txt"
          @click="slideChange(i)"
        >
          {{ txt }}
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { gsap, ScrollTrigger } from "@/utils/gsapConfig";
import { SECOND_GRAB_ENGINE } from "@/config/image.js";
import { initExposureTrack } from "@/utils/track.js";
import "swiper/css";
import Swiper from "swiper/bundle";
import "swiper/swiper-bundle.css";
export default {
  name: "SecondGrabEngine",
  data() {
    return {
      SECOND_GRAB_ENGINE,
      activeIndex: 0,
      pagination: ["抢演唱会门票", "抢博物馆门票", "抢苏超门票"],
      refreshKey: 1,
    };
  },
  computed: {
    ...mapGetters(["isMobile", "isPad", "isPC"]),
  },
  mounted() {
    this.swiperTimer = null;
    this.initSwiper();
    if (this.isPC) {
      this.initGsap();
    }
    initExposureTrack(".second-grab-engine")();
    let lastWidth = window.innerWidth;
    this.resizeHandler = () => {
      if (this.isPC) {
        if (Math.abs(window.innerWidth - lastWidth) > 10) {
          lastWidth = window.innerWidth;
          if (this.scaleScrollTrigger) {
            this.scaleScrollTrigger.kill();
          }
          if (this.resumeScrollTrigger) {
            this.resumeScrollTrigger.kill();
          }
          if (this.swiper) this.swiper = null;
          this.refreshKey++;
          this.$nextTick(() => {
            this.initGsap();
            this.initSwiper();
            this.activeIndex = 0
          });
        }
      }
    };
    window.addEventListener("resize", this.resizeHandler);
  },
  methods: {
    slideChange(index) {
      this.swiper.slideTo(index);
    },
    initSwiper() {
      this.swiper = new Swiper(".sge-swiper", {
        allowTouchMove: false,
        on: {
          slideChange: (swiper) => {
            this.activeIndex = swiper.activeIndex;
            this.$nextTick(() => {});
          },
        },
      });
    },
    initGsap() {
      const tl = gsap.timeline({
        paused: true,
      });
      const textDom = document.querySelector(".second-grab-engine .text-box");
      const paginationDom = document.querySelector(
        ".second-grab-engine .pagination"
      );
      function textShow() {
        textDom.classList.add("show");
        paginationDom.classList.add("show");
      }
      function textHide() {
        textDom.classList.remove("show");
        paginationDom.classList.remove("show");
      }
      tl.to(".bgbox span", { opacity: 0, onComplete: textShow })
        .to(".bgbox", { transform: "scale(0.9)" }, "<")
        .to(".bgbox .hand", { transform: "translateY(31.25%)" }, "<")
        .from(
          ".mask",
          {
            borderTopWidth: 0,
            borderLeftWidth: 0,
            borderRightWidth: 0,
            borderBottomWidth: 0,
          },
          "<"
        )
        .from(".mask-inside", { borderWidth: 0 }, ">-0.1");

      if (!textDom) return;
      this.scaleScrollTrigger = ScrollTrigger.create({
        id: "scaleScrollTrigger",
        trigger: ".second-grab-engine", // 触发滚动的元素
        start: "bottom bottom", // 元素底部进入视口底部时触发
        end: "+=500", //
        pin: true,
        anticipatePin: 1, // 在定格前预先触发的距离
        scrub: false, // 关闭跟手，动画自动播放
        // markers: true,
        onUpdate: (self) => {
          // 计算当前滚动位置占总滚动距离的比例
          const progress = self.progress;
          if (progress > 0.1) {
            // 不能是0，因为页面刷新时候progress大于0
            tl.play();
          }
        },
      });
      this.resumeScrollTrigger = ScrollTrigger.create({
        id: "resumeScrollTrigger",
        trigger: ".second-grab-engine", // 触发滚动的元素
        start: "top bottom", // 元素底部进入视口底部时触发
        end: "top bottom", //
        pin: false,
        onLeaveBack: () => {
          this.swiper.slideTo(0);
          tl.pause().progress(0); // 重置动画
          textHide();
        },
      });
    },
  },
};
</script>
<style>
.pin-spacer-scaleScrollTrigger {
  background: #000;
}
</style>
<style lang="scss" scoped>
.second-grab-engine {
  height: 900 * $px1920vw + vw;
  position: relative;
  background: #000;
  .text-box {
    width: 100%;
    text-align: center;
    position: absolute;
    top: 100 * $px1920vw + vw;
    left: 50%;
    transform: translateX(-50%);
    opacity: 0;
    transition: opacity ease-in-out 0.5s;
    z-index: 2;
    &.show {
      opacity: 1;
    }
    .subtitle {
      font-size: 28 * $px1920vw + vw;
      line-height: 33.6 * $px1920vw + vw;
      color: #2785ff;
      margin-bottom: 12 * $px1920vw + vw;
    }
    .title {
      font-size: 64 * $px1920vw + vw;
      line-height: 76.8 * $px1920vw + vw;
      color: #ffffff;
      margin-bottom: 24 * $px1920vw + vw;
    }
    .content {
      font-size: 18 * $px1920vw + vw;
      line-height: 25.2 * $px1920vw + vw;
      color: rgba(255, 255, 255, 0.8);
    }
  }
  .sge-swiper {
    width: 100%;
    // height: 550 * $px1920vw + vw;
    height: 100%;
    .swiper-slide {
      height: 100%;
      width: 100%;
      position: relative;
      img,
      picture {
        width: 1200 * $px1920vw + vw;
        height: 500 * $px1920vw + vw;
        border-radius: 24 * $px1920vw + vw;
        margin: 331 * $px1920vw + vw auto 0;
      }
      .bgbox {
        width: 100%;
        height: 100%;
        color: #fff;
        overflow: hidden;
        position: absolute;
        span {
          font-size: 160 * $px1920vw + vw;
          line-height: 192 * $px1920vw + vw;
          letter-spacing: 0.2em;
          position: absolute;
          top: 340 * $px1920vw + vw;
          z-index: 1;
          &.mq {
            left: 404 * $px1920vw + vw;
          }
          &.yq {
            left: 1164 * $px1920vw + vw;
          }
        }
        .bgimg {
          position: absolute;
          width: 100%;
          height: 100%;
          border-radius: 0;
          margin: 0;
          top: 0;
          left: 0;
        }
        .hand {
          position: absolute;
          width: 1200 * $px1920vw + vw;
          height: 734 * $px1920vw + vw;
          bottom: 0;
          right: 360 * $px1920vw + vw;
        }
      }
      .mask {
        width: 100%;
        height: 100%;
        border: 0px solid #000;
        border-top-width: 331 * $px1920vw + vw;
        border-left-width: 360 * $px1920vw + vw;
        border-right-width: 360 * $px1920vw + vw;
        border-bottom-width: 69 * $px1920vw + vw;
        box-sizing: border-box;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 2;
      }
      .mask-inside {
        width: 64vw;
        height: 27.5vw;
        box-sizing: border-box;
        position: absolute;
        left: 18vw;
        top: 16.5vw;
        z-index: 2;
        border: 15.55 * $px1920vw + vw solid #000000;
        border-radius: 2vw;
      }
    }
  }
  .pagination {
    width: max-content;
    position: absolute;
    bottom: 6 * $px1920vw + vw;
    left: 50%;
    transform: translateX(-50%);
    z-index: 2;
    opacity: 0;
    transition: opacity ease-in-out 0.5s;
    border-bottom: 1px solid;
    cursor: pointer;
    &.show {
      opacity: 1;
    }
    ul {
      position: relative;
      line-height: 0;
      &::after {
        position: absolute;
        content: "";
        width: 100%;
        height: 1 * $px1920vw + vw;
        background: rgba(255, 255, 255, 0.6);
        bottom: -6 * $px1920vw + vw;
        left: 0;
      }
      li {
        display: inline-block;
        color: rgba(255, 255, 255, 0.6);
        font-size: 24 * $px1920vw + vw;
        line-height: 28.8 * $px1920vw + vw;
        position: relative;
        margin-right: 48 * $px1920vw + vw;
        &:last-child {
          margin: 0;
        }
        &.active {
          color: #fff;
          &::after {
            position: absolute;
            content: "";
            width: 100%;
            height: 3 * $px1920vw + vw;
            background: rgba(255, 255, 255, 1);
            bottom: -6 * $px1920vw + vw;
            left: 0;
          }
        }
      }
    }
  }
}
.isPad,
.isMobile {
  .second-grab-engine {
    height: 600 * $px676vw + vw;
    .text-box {
      top: 36 * $px676vw + vw;
      opacity: 1;
      .subtitle {
        font-size: 12 * $px676vw + vw;
        line-height: normal;
        margin-bottom: 6 * $px676vw + vw;
      }
      .title {
        font-size: 25 * $px676vw + vw;
        line-height: normal;
        margin-bottom: 12 * $px676vw + vw;
      }
      .content {
        font-size: 12 * $px676vw + vw;
        line-height: 16 * $px676vw + vw;
      }
    }
    .sge-swiper {
      width: 100%;
      height: 480 * $px676vw + vw;
      .swiper-slide {
        img,
        picture {
          width: 100%;
          height: 100%;
          border-radius: 0;
          margin: 0;
        }
      }
    }
    .pagination {
      width: max-content;
      bottom: 36 * $px676vw + vw;
      opacity: 1;
      ul {
        &::after {
          height: 0.67 * $px676vw + vw;
          bottom: -4.67 * $px676vw + vw;
        }
        li {
          font-size: 16 * $px676vw + vw;
          line-height: 19.2 * $px676vw + vw;
          margin-right: 32 * $px676vw + vw;
          &:last-child {
            margin-right: 0;
          }
          &.active {
            &::after {
              height: 3 * $px676vw + vw;
              bottom: -4.67 * $px676vw + vw;
            }
          }
        }
      }
    }
  }
}
.isMobile {
  .second-grab-engine {
    height: 530 * $px360vw + vw;
    .text-box {
      top: 36 * $px360vw + vw;
      opacity: 1;
      .subtitle {
        font-size: 12 * $px360vw + vw;
        line-height: normal;
        margin-bottom: 6 * $px360vw + vw;
      }
      .title {
        font-size: 25 * $px360vw + vw;
        line-height: normal;
        margin-bottom: 12 * $px360vw + vw;
      }
      .content {
        font-size: 12 * $px360vw + vw;
        line-height: 16 * $px360vw + vw;
      }
    }
    .sge-swiper {
      width: 100%;
      height: 430 * $px360vw + vw;
    }
    .pagination {
      width: max-content;
      bottom: 26 * $px360vw + vw;
      opacity: 1;
      ul {
        &::after {
          height: 0.67 * $px360vw + vw;
          bottom: -4.67 * $px360vw + vw;
        }
        li {
          font-size: 16 * $px360vw + vw;
          line-height: 19.2 * $px360vw + vw;
          margin-right: 12 * $px360vw + vw;
          &.active {
            &::after {
              height: 3 * $px360vw + vw;
              bottom: -4.67 * $px360vw + vw;
            }
          }
        }
      }
    }
  }
}
</style>